import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get carpetType
export const getCarpetType = createAsyncThunk("carpetType/getCarpetType", async (postsPerPage, { rejectWithValue }) => {
  try {
    const { data } = await API.getCarpetType(postsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// get all carpetType
export const getAllCarpetType = createAsyncThunk("carpetType/getAllCarpetType", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllCarpetType();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// get previous
export const getPrevious = createAsyncThunk("carpetType/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});
// get next
export const getNext = createAsyncThunk("carpetType/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// get particular page
export const getPageCarpetType = createAsyncThunk("carpetType/getPageCarpetType", async (data, { rejectWithValue }) => {
  const { number, postsPerPage } = data;
  try {
    const { data } = await API.getPageCarpetType(number, postsPerPage);
    return data;
  } catch (error) {
   return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// create carpetType
export const createCarpetType = createAsyncThunk("carpetType/createCarpetType", async (data, { rejectWithValue }) => {
  const { name, description } = data;
  try {
    const body = JSON.stringify({ name, description });
    const { data } = await API.createCarpetType(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});
export const updateCarpetType = createAsyncThunk("carpetType/updateCarpetType", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, description } = values;
  try {
    const body = JSON.stringify({ name, description });
    const { data } = await API.updateCarpetType(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// handle search
export const handleSearch = createAsyncThunk("carpetType/handleSearch", async (data, { rejectWithValue }) => {
  const { search, postsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, postsPerPage);
    return data;
  } catch (error) {
   return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});
